// features/videos/watchGrid.ts — the watch page grid for each Up Next placement
// (useWatchRail.ts): the player on top, then details, then comments; Up Next beside the
// details in theater mode, under them below desktop, and not in the page at all when the
// shell's right column holds it.
import styled, { css } from 'styled-components';
import type { WatchRailPlace } from './useWatchRail';

export const WatchGrid = styled.div<{ $rail: WatchRailPlace }>`
  display: grid;
  column-gap: 24px;
  align-items: start;
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas: 'player' 'details' 'comments';
  ${({ $rail }) =>
    $rail === 'beside' &&
    css`
      grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
      grid-template-areas: 'player player' 'details rail' 'comments rail';
    `}
  ${({ $rail }) =>
    $rail === 'below' &&
    css`
      grid-template-areas: 'player' 'details' 'rail' 'comments';
    `}
`;

export const PlayerArea = styled.div`
  grid-area: player;
  min-width: 0;
`;

export const DetailsArea = styled.div`
  grid-area: details;
  min-width: 0;
`;

export const RailArea = styled.div`
  grid-area: rail;
  min-width: 0;
  margin-top: 14px;
`;

export const CommentsArea = styled.div`
  grid-area: comments;
  min-width: 0;
  margin-top: 24px;
`;
